import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ActiveBusDriverVM, BusVM, BusWithDriverVM } from '../models/BusModel';
import { UserVM } from '../models/UserModel';

@Injectable({
  providedIn: 'root'
})
export class BusService {
  hostPath: string = JSON.parse(environment.IDENTITY);
  busPath = 'Shuttlebuss/Shuttlebuss.Service/bus';

  constructor(private http: HttpClient) {}


  public getBuses(): Observable<BusVM[]> {
    const URL = `${this.hostPath}${this.busPath}/bus`;
    return this.http.get<BusVM[]>(URL).pipe(
      map(orderShuttle => {
        return orderShuttle;
      }),
      catchError(this.handleError)
    );
  }

  public getBusId(busId: string): Observable<BusVM> {
    const URL = `${this.hostPath}${this.busPath}/bus/${busId}`;
    return this.http.get<BusVM>(URL).pipe(
      map(orderShuttles => {
        return orderShuttles;
      }),
      catchError(this.handleError)
    );
  }

  public getBusDrivers(organizationId: string): Observable<UserVM[]> {
    const URL = `${this.hostPath}${this.busPath}/busdriver/${organizationId}`;
    return this.http.get<UserVM[]>(URL).pipe(
      map(users => {
        return users;
      }),
      catchError(this.handleError)
    );
  }

  public getMyBusOptions(): Observable<BusWithDriverVM[]> {
    const URL = `${this.hostPath}${this.busPath}/mybus/options`;
    return this.http.get<BusWithDriverVM[]>(URL).pipe(
      map(buses => buses),
      catchError(this.handleError)
    );
  }

  public getMyBus(): Observable<ActiveBusDriverVM> {
    const URL = `${this.hostPath}${this.busPath}/mybus`;
    return this.http.get<ActiveBusDriverVM>(URL).pipe(
      map(activeBusDriver => activeBusDriver),
      catchError(this.handleError)
    );
  }

  public setMyBus(busId: string | null): Observable<ActiveBusDriverVM> {
    const URL = `${this.hostPath}${this.busPath}/mybus`;
    return this.http.post<ActiveBusDriverVM>(URL, { busId }).pipe(
      map(activeBusDriver => activeBusDriver),
      catchError(this.handleError)
    );
  }

  private handleError(error: Response | any) {
    const errMsg = error.message
      ? error.message
      : error.status
      ? `${error.status} - ${error.statusText}`
      : 'Server error';
    console.error(`orderShuttleService.handleError ${errMsg}`);
    return throwError(error);
  }
}
